/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, Vue} from "vue-property-decorator";
import {UserModule} from '@/store/modules/user'
import {
    getFinanceOrderListByCreatedUserId, getFinanceMarketCostById, setFinanceMarketCostById,setPayeeInfo
} from '@/api/financial-center'
import {menuBtn} from '@/utils/menu_level2_button'
import {delNullProperty} from "@/utils";
import {formatDate} from '@/utils/timeFilter'
import {  payInfoList, getBranchList } from '@/api/common'
import * as math from 'mathjs'
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import {getAgeByCardId} from "@/utils/checkIDCard";
import CommonData from "@/utils/commonData";


// 金额的校验
const checkAge = (rule, value, callback) => {
    if (value) {
        const reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
        if (!reg.test(value)) {
            callback(new Error('请输入数字值！'))
        } else {
            // if (value > 2000) {
            //     callback(new Error("请输入不超过2000的数！"))
            // } else {
                callback()
            // }
        }
    } else{
        callback(new Error("金额不可为空！"))
    }
}

@Component({
    components:{
        MoreUsersFilter
    }
})
export default class MarketCostInfo extends Vue {
    select = '0'
    tableData = []
    logList = []
    tableRandom = Math.random()
    tableKey = Math.random()
    formData = {
        code: '',//
        directorUserRealName: '', //负责人
        types: '',// 费用类型
        other: '',// 费用类型 --- 输入框
        financeOrderId: '',
        price: '',
        score: '',
        reason: '', //申请原因
        directorUserId: UserModule.userId || '',
        reward: '0'
    }
    orderDialogSelectTable = [] //选中数据
    tableDataOrder = [] //明细列表
    saveDraftDialogShow = false
    errorDialogShow = false
    isDraft = '0'
    backMoneyId: number = null
    orderId: number = null
    editUserName = '' // 编辑的时候使用
    editCreatedAt: Date = null // 编辑的时候用来返显
    draftId: number = null // 草稿id
    feeTypeList = [
        {label: '合作顾问额外奖励', value: '0'},
        {label: '中小顾问积分奖励', value: '1'},
        {label: '学生奖学金申请', value: '2'},
        {label: '市场活动费用', value: '3'},
        {label: '其他', value: '4'}
    ] // 费用类型
    operationShow = true
    backMoneyStatus = ''
    showInput: any = false
    queryType = ""
    status: any
    costId = NaN
    isUpdatedData = '0'
    orderDialog = false
    orderDialogInputValue = ''
    orderDialogTaleData = []
    orderDialogTotal = 0
    orderDialogPage = 1
    orderDialogTableLoading = false
    orderDialogSelect = {
        id: null, //订单id
        code: '', //订单code
        price: '', //订单金额
    }
    currentPage = 1
    pagesize = 20
    customerName = ''
    sourceName = ''
    numberlimit = [{required: true, validator: checkAge, trigger: ['change', 'blur']}]
    formRules = {
        types: [{required: true, message: '请选择费用类型', trigger: 'change'}],
        financeOrderCode: [{required: true, message: '请选择订单', trigger: ['change', 'blur']}],
        reason: [{ required: true, message: '请输入申请原因', trigger: 'blur' }],
        // price: [{required: true, message: '请输入金额', trigger: ['change', 'blur']}],
    }
    isRules = false
    activities =[]
    disabledBtn = false
    isShow = null
    // 2023-4-20 新增
    newAccountDialog = false
    searchName: any =null //开户名称
    searchCardName: any =null //银行卡号
    searchBranchName: any = null //开户网点
    branchInfoList = [] // 开户网点数据
    branchPage = 1
    branchLimit = 20
    formRule = {
        name: [{ required: true, message: '请选择开户名称', trigger: 'change' }],
        cardNum: [{ required: true, message: '请选择银行卡号', trigger: 'change' }],
        phoneNo: [{ required: true, message: '请填写电话号码', trigger: ['change','blur' ]}],
        certificateNo: [{ required: true, message: '请填写身份证号', trigger: ['change','blur' ]}],
        selectedDetailArea: [{ required: true, message: '请填写详细地址信息', trigger: ['change','blur' ]}],
        selectedArea: [{ required: true, message: '请填写常住地址信息', trigger: ['change','blur' ]}],
    }
    payInfo: any = {
        name: '',
        cardNum: '',
        branch: '',
        type: '',
        page: 1,
        limit: 20,
        id: '',
        selectedArea: [],
        selectedDetailArea: null
    }
    payeeInfoList = [] // 开户名称数据
    payInfoLoading = false
    accountTypeList = [
        {value: 'PUBLIC', label: '对公账户'},
        {value: 'PERSONAL', label: '个人账户'},
    ]
    type = '' //账户类型
    name = '' //开户名称
    cardNum = '' //银行卡号
    branch = '' //开户网点
    phoneNo = '' //手机号
    certificateNo = '' // 身份证号
    accountEditBtn = false
    rewardList = [
        {label: '实物', value: '0'},
        {label: '非实物', value: '1'},
    ]
    financeMarketCostAccount = null
    syncDialogVisible = false
    msg = ''
    certificateNoDisabled = true
    phoneNoDisabled = true
    loading = false
    options = CommonData.regionData
    selectedOptions = []
    get userName() {
        return UserModule.userName
    }


    get directorUserId() {
        return UserModule.userId
    }

    get orderAllPrice() {
        let num = 0
        this.tableDataOrder.forEach(item => {
            num = math.number(math.add(math.bignumber(num), math.bignumber(Number(item.priceOrScore))))
        })
        return num
    }
    get orderAllScore() {
        let num = 0
        this.tableDataOrder.map(item => {
            if(item.price){
                num = math.number(math.add(math.bignumber(num), math.bignumber(Number(item.price)* 0.01)))
            }else if(item.financeOrderPrice){
                num = math.number(math.add(math.bignumber(num), math.bignumber(Number(item.financeOrderPrice)* 0.01)))
            }else{
                return
            }
            return
        })

        return num
    }

    menuBtn = menuBtn
    formatDate = formatDate


    created() {
        this.costId = Number(this.$route.query.id)
        this.status = this.$route.query.status
        this.isShow = this.$route.query.isShow

        this.queryType = this.$route.query.type as string
        if (this.$route.query.isUpdatedData) {
            this.isUpdatedData = this.$route.query.isUpdatedData as string
        }
        if (this.queryType) {
            this.showInput = true
        }
        this.getFinanceMarketCostById()

    }

    // 详情
    async getFinanceMarketCostById() {
        this.loading = true
        await getFinanceMarketCostById(
            {
                id: this.costId,
                isUpdatedData: this.isUpdatedData
            }).then((res: any)=>{
        this.tableDataOrder = res.financeMarketCost.financeMarketCostDetailList
        this.formData = res.financeMarketCost
        //    审批流程
        this.activities = res.financeMarketCost.messageReviewList

        this.editUserName = res.financeMarketCost.createdUserRealName
        this.logList = res.financeMarketCost.financeMarketCostLogList
        this.financeMarketCostAccount = res.financeMarketCost.financeMarketCostAccount
        if (this.financeMarketCostAccount) {
            this.payInfo = res.financeMarketCost.financeMarketCostAccount
            this.payInfo.status = this.payInfo.status == '0' ? '未打款' :( this.payInfo.status == '1' ? '打款中':(this.payInfo.status == '2'? '已打款':'同步失败'))
            if(res.financeMarketCost.financeMarketCostAccount.provinces){
                this.$set(this.payInfo,'selectedArea', [res.financeMarketCost.financeMarketCostAccount.provinces, res.financeMarketCost.financeMarketCostAccount.city,res.financeMarketCost.financeMarketCostAccount.districts])
              } else {
                this.$set(this.payInfo, 'selectedArea', [])
                this.selectedOptions = []
              }
              this.$set(this.payInfo,'selectedDetailArea', (res.financeMarketCost.financeMarketCostAccount.others?res.financeMarketCost.financeMarketCostAccount.others:''))
        }
        this.formData.reward = res.financeMarketCost.reward == '非实物' ? '1' : '0'

        if (this.financeMarketCostAccount && !this.financeMarketCostAccount.certificateNo) {
            this.certificateNoDisabled = false
        } else {
            this.certificateNoDisabled = true
        }
        if (this.financeMarketCostAccount && !this.financeMarketCostAccount.phoneNo) {
            this.phoneNoDisabled = false
        } else {
            this.phoneNoDisabled = true
        }
        this.getSelectedLabels()
        this.loading = false
        }).catch(err=>{
            this.loading = false
        })
    }
    // 明细删除
    clickDelOrder(row) {
        if (row.id) {
            this.tableDataOrder = this.tableDataOrder.filter((item => item.id !== row.id))
        } else if (row.financeOrderId) {
            this.tableDataOrder = this.tableDataOrder.filter((item => item.financeOrderId !== row.financeOrderId))
        }
    }

    changeHandleReward(val) {
        this.$set(this.formData, 'reward', val)
    }

    edit() {
        this.showInput = true
    }
    clickAddOrder() {
        if(!this.formData.types) {
            this.$message.error('请选择费用类型')
            return
        }
        this.select = '0'
        this.currentPage = 1
        this.orderDialogInputValue = ''
        this.customerName = ''
        this.sourceName = ''
        this.orderDialog =  true
        this.getFinanceOrderListByCreatedUserId()
        this.defaultChecked()
    }
    defaultChecked(){
        this.$nextTick(() => {
            let order = (this.$refs.orderDialogTable as HTMLFormElement)
            order.clearSelection();
            this.tableDataOrder.forEach(row => {
                order.toggleRowSelection(row, true)
            })
        })
    }


    // 编辑保存
    saveEditMarketCost() {
        let financeMarketCostDetailList = []
        financeMarketCostDetailList = this.tableDataOrder.map(item => ({ financeOrderId: item.financeOrderId ? item.financeOrderId : item.id, priceOrScore: String(item.priceOrScore) }))

        /* * 判断数组的每一项是否都不为空*/
        const isAllZero = financeMarketCostDetailList.every(item => (item.priceOrScore !== 'undefined' && item.priceOrScore !== ''));
        if (!isAllZero) {
            this.$message.error('有未填写本次费用金额的订单，请去填写')
            return;
        }
        /*如果回显的数据未更改*/
        if (this.formData.reward == '实物') {
            this.formData.reward = '0'
        } else if (this.formData.reward == '非实物') {
            this.formData.reward = '1'
        }

        const obj = {
            id: this.costId,
            types: this.formData.types,
            other: this.formData.other,
            reason: this.formData.reason, //申请原因
            financeMarketCostDetailList: financeMarketCostDetailList,
            directorUserId: this.formData.directorUserId,
            reward: this.formData.reward,
            // financeOrderId: this.formData.financeOrderId,
            // price: this.formData.price,
            // score: this.formData.score,
            payeeInfoId: this.payInfo.id ? this.payInfo.id : this.payInfo.payeeInfoId ? this.payInfo.payeeInfoId : '', //易快报收款账户id
            certificateNo : this.payInfo.certificateNo,
            phoneNo : this.payInfo.phoneNo,
            provinces:null,
            city: null,
            districts: null,
            others: null
        };
        if(this.payInfo.selectedArea && this.payInfo.selectedArea.length) {
            obj.provinces = this.payInfo.selectedArea[0]
            obj.city = this.payInfo.selectedArea[1]
            obj.districts = this.payInfo.selectedArea[2]
            obj.others = this.payInfo.selectedDetailArea?this.payInfo.selectedDetailArea:null
          }
        let flag = true;
       
        (this.$refs['formRef'] as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                flag = false
            }
        });
        if(this.formData.reward == '非实物' || this.formData.reward == '1'){
            (this.$refs['formRef1'] as HTMLFormElement).validate((valid: boolean) => {
                if (!valid) {
                    flag = false;
                }
            })
        }
      
        if(flag){
             if (this.formData.types == '4' && !this.formData.other) {
                 this.$message.error('其他不可为空！')
                 return
             }

            /*如果是个人账户 身份证号码校验是否符合规则*/
            let flag = true
            if (this.payInfo.type === '个人账户') {
                if (!getAgeByCardId(this.payInfo.certificateNo)) {
                    flag = false
                    return
                }
                /*如果是个人账户，正则校验手机号格式是否正确*/
                if (this.payInfo.phoneNo && !(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.payInfo.phoneNo))) {
                    this.$message.error('请输入正确的手机号');
                    flag = false
                }
            }
            if (!flag) {
                return;
            }
            // if ((this.formData.reward == '非实物' || this.formData.reward == '1') && this.payInfo.type === '个人账户' && (this.payInfo.selectedArea.length < 1 || !this.payInfo.selectedDetailArea)) {
            //     this.$message.error('请输入常住地址信息！')
            //     return;
            // }
            this.disabledBtn = true
            this.loading = true
             setFinanceMarketCostById(delNullProperty(obj)).then(() => {
                 this.$message.success('编辑成功')
                 this.loading = false
                 setTimeout(() => {
                     window.close()
                     this.$router.push({
                         path: 'marketCost',
                         query: {}
                     })
                 }, 1500)
             }).catch((err: Error) => {
                 if (err.message === '审批流报错') {
                     this.errorDialogShow = true
                 }
                 this.disabledBtn = false
                 this.loading=  false
             })
        }else{
            console.log('err')
        }

    }

    // 选过的订单不可选
    orderTableSelect(row) {
        return row.isSelect == '1'
    }



    // 订单/回款列表change
    handleOrderFilter(val) {
        this.select = val
        this.orderDialogInputValue = ''
    }

    // 选择订单列表
    choiceOrder(e) {
        this.orderDialog = true
        this.currentPage = 1
        this.getFinanceOrderListByCreatedUserId()
        e.target.blur()
    }


    getRowKeys(row) {
        return row.id ? row.id : row.financeOrderId
        // if(row.financeOrderId){
        //     return `${row.financeOrderId}`
        // }
        // if(row.id){
        //     return `${row.id}`
        // }
    }


    // 订单
    handleOrderRowClick(row) {
        (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row)
    }

    closePage() {
        window.close()
    }
    onExchangeChange(index){
        let tmpObj = this.tableDataOrder[index];
        this.$set(this.tableDataOrder, index, tmpObj);
    }
    changeTypes(e) {
        if (e == 1) {  //积分
            this.isRules = false
            this.tableDataOrder.forEach((item,index) => {
                item.priceOrScore = Number(item.financeOrderPrice) / 100
            })
        } else {
            this.isRules = true
        }
        // this.formData.score = ''
        // this.$set(this.formData, 'price', '')
        // this.formData.financeOrderId = ''
        // this.formData.financeOrderCode = ''
        this.formData.reward = '0'
        this.tableDataOrder = []
    }

    // 订单列表搜索
    async clickorderDialogFilter() {
        if(this.select == '1'){ //具体来源
            this.sourceName = this.orderDialogInputValue
            this.customerName = ''
        }else if(this.select == '0'){ //客户名称
            this.customerName = this.orderDialogInputValue
            this.sourceName = ''
        }
        this.currentPage = 1
        this.getFinanceOrderListByCreatedUserId()
    }
    clickOrderDialogTableRow(row) {
        if (row.isSelect == '1') {
            (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row)
        }
    }
    // 费用金额正则
    handleOninput(num,limit) {
        var str = num
        var len1 = str.substr(0, 1)
        var len2 = str.substr(1, 1)
        //如果第一位是0，第二位不是点，就用数字把点替换掉
        if (str.length > 1 && len1 == 0 && len2 != ".") {
            str = str.substr(1, 1)
        }
        //第一位不能是.
        if (len1 == ".") {
            str = ""
        }
        //限制只能输入一个小数点
        if (str.indexOf(".") != -1) {
            var str_ = str.substr(str.indexOf(".") + 1)
            if (str_.indexOf(".") != -1) {
            str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1)
            }
        }
        //正则替换
        str = str.replace(/[^\d^\.]+/g, '') // 保留数字和小数点
        if (limit / 1 === 1) {
            str = str.replace(/^\D*([0-9]\d*\.?\d{0,1})?.*$/,'$1') // 小数点后只能输 1 位
        } else {
            str = str.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1') // 小数点后只能输 2 位
        }
        return str
    }
    // 积分 订单金额/100
    thisBackMoneyChange(row, val){
        val = this.handleOninput(val,'2')
        if(this.isRules){
            this.tableDataOrder.forEach((item,index) => {
                if(item.financeOrderId === row.id){
                    item.priceOrScore = val
                }
            })
        }
    }
    // 订单列表确定事件
    orderDialogConfirm() {
        this.tableDataOrder = []
        this.orderDialogSelectTable.map(item => {
            const Index = this.tableDataOrder.findIndex((items) => {return items.id === (item.financeOrderId ? item.financeOrderId : item.id )})
            if(Index == -1){
                if(this.formData.types == '1'){
                    if(item.price){
                        item.priceOrScore = Number(item.price) * 0.01
                    }else if(item.financeOrderPrice){
                        item.priceOrScore = Number(item.financeOrderPrice) * 0.01
                    }
                }
                this.tableDataOrder.push({
                    ...item,
                    financeOrderCode: item.financeOrderCode ? item.financeOrderCode : item.code,
                    financeOrderPrice: item.financeOrderPrice ? item.financeOrderPrice : item.price,
                    priceOrScore: item.priceOrScore ? item.priceOrScore : 0, // 费用金额
                    financeOrderCaseStatus: item.caseStatus ? item.caseStatus : (item.financeOrderCaseStatus?item.financeOrderCaseStatus:''), // 转案状态
                })
            }
        })
        this.orderDialog = false
        this.orderDialogInputValue = ''
        // this.formData.financeOrderId = this.orderDialogSelect.id
        // this.formData.financeOrderCode = this.orderDialogSelect.code
        // if( this.formData.types =='1'){
        //     (this.formData.score as any) = String((this.orderDialogSelect.price as any ) * 0.01)
        // }
        // this.orderDialog = false
        // this.orderDialogInputValue = ''
        // this.tableData = []
    }

    handleorderRowClick(row) {
        if (row.isSelect == '1') {
            (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row)
        }
    }

    // 订单列表change
    orderDialogSelectionChange(selectionArr: any[]) {
        this.orderDialogSelectTable = selectionArr
        if (this.tableDataOrder.length > 0) {
            this.tableDataOrder.map(item => {
                this.orderDialogSelectTable.map(items => {
                    if (items.id) {
                        if (items.id == item.id || items.id == item.financeOrderId) {
                            items.priceOrScore = item.priceOrScore
                        }
                    } else if (items.financeOrderId) {
                        if (items.financeOrderId == item.financeOrderId || items.financeOrderId == item.id) {
                            items.priceOrScore = item.priceOrScore
                        }
                    }
                })
            })
        }
        // if (selectionArr.length > 0) {
        //     this.orderDialogSelect = JSON.parse(JSON.stringify(selectionArr[0]))
        //     if (selectionArr.length > 1) {
        //         const orderTableToggle = this.$refs.orderDialogTable as HTMLFormElement
        //         orderTableToggle.clearSelection()
        //         orderTableToggle.toggleRowSelection(selectionArr.pop())
        //     }
        // } else {
        //     for (const key in this.orderDialogSelect) {
        //         this.orderDialogSelect[key] = null
        //     }
        // }
    }

    // 订单弹框取消
    doCancel() {
        this.orderDialogSelectTable.map(item => {
            this.tableDataOrder.map(items => {
                if(item.financeOrderId !== items.financeOrderId){
                    const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
                    orderDialogTable.clearSelection()
                }
            })
        })

        if(this.tableData.length > 0){
            const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
            this.tableData.forEach(row => {
                orderDialogTable.toggleRowSelection(row,true)
            });
        }else {
            const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
            orderDialogTable.clearSelection()
        }
        this.orderDialog = false
    }


    // 订单列表
    async getFinanceOrderListByCreatedUserId() {
        this.orderDialogTableLoading = true
        const obj = {
            financeMarketCostId:this.costId,
            customerName: this.customerName,
            page: this.currentPage,
            limit: this.pagesize,
            source: this.sourceName,
            types: this.formData.types
        }
        await getFinanceOrderListByCreatedUserId(delNullProperty(obj)).then((data:any)=>{
            this.orderDialogTaleData = data.financeOrderList
            this.orderDialogTotal = data.allNum
            this.orderDialogTableLoading = false
            // this.tableRandom = Math.random();

            // // 编辑订单回显
            // (this.$refs.orderDialogTable as HTMLFormElement).clearSelection();
            // this.orderDialogTaleData.forEach(row => {
            //     if (row.id == this.formData.financeOrderId) {
            //         (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row)
            //     }
            // })
        }).catch(()=>{
            this.orderDialogTableLoading = false
        })

    }


    handleSizeChange(val) {
        this.pagesize = val
        this.getFinanceOrderListByCreatedUserId();
    }

    handleCurrentChange(val) {
        this.currentPage = val
        this.getFinanceOrderListByCreatedUserId();
    }


    /*
    * 2023-4-20 新增*/
    // 新增账户打开弹窗
    clickNewAccount(){
        this.newAccountDialog = true
        this.getBranchList(); //开户网点
    }

    // 开户网点
    async getBranchList() {
        let objs = {
            name: this.searchBranchName,
            page: this.branchPage,
            limit: this.branchLimit,
        }
        const data: any = await getBranchList(delNullProperty(objs))
        this.branchInfoList = [...this.branchInfoList, ...data.branchList]
        let result = []
        let obj = {}
        for(let i =0; i<this.branchInfoList.length; i++){
            if(!obj[this.branchInfoList[i].name]){
                result.push(this.branchInfoList[i]);
                obj[this.branchInfoList[i].name] = true;
            }
        }
        this.branchInfoList = result
    }

    async handlePayInfo(){
        if((this.payeeInfoList.length == 0 || !this.searchName) && !this.payInfo.name){
            this.searchName = null
            this.payInfo.page = 1
            const result: any = await payInfoList({page: this.payInfo.page,  name: this.searchName })
            this.payeeInfoList = result.payeeInfoList
        }
        if(this.payInfo.name){
            if (this.searchCardName && this.payInfo.cardNum) {
                this.searchName = this.payInfo.name
                this.payeeInfoList = []
                this.payInfo.page = 1
            } else {
                this.payeeInfoList = []
                this.payInfo.page = 1
            }
            const result: any = await payInfoList({page: this.payInfo.page,  name: this.searchName })
            this.payeeInfoList = result.payeeInfoList
        }
    }

    async handleRemotePayInfo (query: any) {
        this.searchName = query.trim();
        this.payInfo.page = 1
        this.payInfo.limit = 20
        if (query !== '') {
            const result: any = await payInfoList({page: this.payInfo.page,  name: query })
            this.payeeInfoList = result.payeeInfoList
        } else {
            this.payeeInfoList = []
            this.payInfoList();
        }
    }
    // 开户名称列表
    async payInfoList() {
        let objs = {
            name: this.searchName,
            cardNum: this.searchCardName,
            page: this.payInfo.page,
            limit: this.payInfo.limit,
        }
        const data: any = await payInfoList(delNullProperty(objs))
        this.payeeInfoList = [...this.payeeInfoList, ...data.payeeInfoList]
        let result = []
        let obj = {}
        for(let i =0; i<this.payeeInfoList.length; i++){
            if(!obj[this.payeeInfoList[i].name]){
                result.push(this.payeeInfoList[i]);
                obj[this.payeeInfoList[i].name] = true;
            }
        }
        this.payeeInfoList = result
    }

    handlePayInfoLoadmore() {
        this.payInfo.page++
        this.payInfoList();
    }

    handleClearPayInfo() {
        this.searchName = null
        this.searchCardName = null
        this.payInfo.cardNum = ''
        this.payInfo.branch = ''
        this.payInfo.id = ''
        this.payInfo.payeeInfoId = ''
        this.payInfo.type = ''
        this.payInfo.page = 1
        this.payInfoList()
    }

    // 开户名称
    handlePayInfoChange (indexVal) {
        this.msg = indexVal.message
        if(indexVal.message){
            this.syncDialogVisible = true
        }
        const indexId = indexVal.id
        let obj = this.payeeInfoList.find((item,index)=> item.id === indexId)
        this.$set(this.payInfo,'name',obj.name)
        this.payInfo.cardNum = obj.cardNum
        this.payInfo.branch = obj.branch
        this.payInfo.id = obj.id
        this.payInfo.payeeInfoId = obj.id
        // this.payInfo.pay = obj.id
        this.payInfo.type = obj.type
        this.$set(this.payInfo,'phoneNo',obj.phoneNo)
        this.$set(this.payInfo,'certificateNo',obj.certificateNo)
        this.$set(this.payInfo, 'selectedArea', [])
        this.$set(this.payInfo, 'selectedDetailArea', '')
        this.selectedOptions = []
        if (obj.certificateNo) {
            this.certificateNoDisabled = true
        } else {
            this.certificateNoDisabled = false
        }
        if (obj.phoneNo) {
            this.phoneNoDisabled = true
        } else {
            this.phoneNoDisabled = false
        }
        //    crm 和 易快报不同步 切换的时候要把请求回来的数据赋值
        if (this.financeMarketCostAccount && this.financeMarketCostAccount.payeeInfoId && (indexId == this.financeMarketCostAccount.payeeInfoId)) {
            // this.$set(this.payInfo, 'phoneNo', this.financeMarketCostAccount.phoneNo)
            // this.$set(this.payInfo, 'certificateNo', this.financeMarketCostAccount.certificateNo)
            if (!this.payInfo.phoneNo) {
                this.$set(this.payInfo, 'phoneNo', this.financeMarketCostAccount.phoneNo)
            }
            if (!this.payInfo.certificateNo) {
                this.$set(this.payInfo, 'certificateNo', this.financeMarketCostAccount.certificateNo)
            }
            if (this.financeMarketCostAccount.certificateNo) {
                this.certificateNoDisabled = true
            } else {
                this.certificateNoDisabled = false
            }
            if (this.financeMarketCostAccount.phoneNo) {
                this.phoneNoDisabled = true
            } else {
                this.phoneNoDisabled = false
            }
        }


    }

    closeSyncDialog(){
        this.syncDialogVisible = false
    }


    // 银行卡号
    async handlePayCardInfo(){
        if((this.payeeInfoList.length == 0 || !this.searchCardName) && !this.payInfo.cardNum){
            this.searchCardName = null
            this.payInfo.page = 1
            const result: any = await payInfoList({page: this.payInfo.page, cardNum: this.searchCardName })
            this.payeeInfoList = result.payeeInfoList
        }
        if(this.payInfo.cardNum){
            if (this.searchName && this.payInfo.name) {
                this.searchCardName = this.payInfo.cardNum
                this.payInfo.page = 1
                this.payeeInfoList = []
            } else {
                this.payeeInfoList = []
                this.payInfo.page = 1
            }
            const result: any = await payInfoList({page: this.payInfo.page, cardNum: this.searchCardName })
            this.payeeInfoList = result.payeeInfoList
        }
    }

    async handleRemotePayCard(query: any) {
        this.searchCardName = query
        this.payInfo.page = 1
        if (query !== '') {
            const result: any = await payInfoList({page: this.payInfo.page, cardNum: query})
            this.payeeInfoList = result.payeeInfoList
        } else {
            this.payeeInfoList = []
            this.payInfoList();
        }
    }


    handlePayCardLoadmore() {
        this.payInfo.page++
        this.payInfoList();
    }

    handleClearPayCard() {
        this.payInfo.name = ''
        this.searchCardName = null
        this.searchName = null
        this.payInfo.branch = ''
        this.payInfo.id = ''
        this.payInfo.type = ''
        this.payInfo.page = 1
        this.payInfo.payeeInfoId = ''
        /*
       * 如果是个人账户清空*/
        this.payInfo.certificateNo = ''
        this.payInfo.phoneNo = ''
        this.payInfoList()
    }


// 银行卡号
    handlePayChangeCard(indexVal) {
        this.msg = indexVal.message
        if(indexVal.message){
            this.syncDialogVisible = true
        }
        const indexId = indexVal.id
        let obj = this.payeeInfoList.find((item, index) => item.id === indexId)
        this.$set(this.payInfo,'name',obj.name)
        this.payInfo.cardNum = obj.cardNum
        this.payInfo.branch = obj.branch
        this.payInfo.id = obj.id
        this.payInfo.type = obj.type
        this.payInfo.payeeInfoId = obj.id
        this.$set(this.payInfo,'phoneNo',obj.phoneNo)
        this.$set(this.payInfo,'certificateNo',obj.certificateNo)
        if (!obj.certificateNo) {
            this.certificateNoDisabled = false
        } else {
            this.certificateNoDisabled = true
        }
        if (!obj.phoneNo) {
            this.phoneNoDisabled = false
        } else {
            this.phoneNoDisabled = true
        }

        //    crm 和 易快报不同步 切换的时候要把请求回来的数据赋值
        if (this.financeMarketCostAccount && this.financeMarketCostAccount.payeeInfoId && (indexId == this.financeMarketCostAccount.payeeInfoId)) {
            // this.$set(this.payInfo, 'phoneNo', this.financeMarketCostAccount.phoneNo)
            // this.$set(this.payInfo, 'certificateNo', this.financeMarketCostAccount.certificateNo)
            if (!this.payInfo.phoneNo) {
                this.$set(this.payInfo, 'phoneNo', this.financeMarketCostAccount.phoneNo)
            }
            if (!this.payInfo.certificateNo) {
                this.$set(this.payInfo, 'certificateNo', this.financeMarketCostAccount.certificateNo)
            }
            if (this.financeMarketCostAccount.certificateNo) {
                this.certificateNoDisabled = true
            } else {
                this.certificateNoDisabled = false
            }
            if (this.financeMarketCostAccount.phoneNo) {
                this.phoneNoDisabled = true
            } else {
                this.phoneNoDisabled = false
            }
        }
        this.$set(this.payInfo, 'selectedArea', [])
        this.$set(this.payInfo, 'selectedDetailArea', '')
        this.selectedOptions = []
    }

    async handleBranchInfo(){
        if((this.branchInfoList.length == 0 || !this.searchBranchName) && !this.branch){
            this.searchBranchName = null
            this.branchPage = 1
            const result: any = await getBranchList({page: this.branchPage, name: this.searchBranchName })
            this.branchInfoList = result.branchList
        }
        if(this.branch){
            this.branchInfoList = []
            this.branchPage = 1
            const result: any = await getBranchList({page: this.branchPage, name: this.branch })
            this.branchInfoList = result.branchList
        }
    }
    async handleRemoteBranch (query: any) {
        this.searchBranchName = query.trim();
        this.branchPage = 1
        this.branchLimit = 20
        if (query !== '') {
            const result: any = await getBranchList({page: this.branchPage,  name: query })
            this.branchInfoList = result.branchList
        } else {
            this.branchInfoList = []
            this.getBranchList();
        }
    }

    handleBranchLoadmore() {
        this.branchPage ++
        this.getBranchList();
    }
    handleClearBranch() {
        this.searchBranchName = null
        this.branch = ''
        this.branchPage = 1
        this.getBranchList()
    }

    handleBranchChange (val) {
        this.branch = val
    }

    changeType(val){
        this.certificateNo = ''
        this.phoneNo = ''
    }

    doCancelAccount(){
        this.type = ''
        this.name = ''
        this.cardNum = ''
        this.branch = ''
        this.certificateNo = ''
        this.phoneNo = ''
        this.newAccountDialog = false
    }

    // 新增账户确认
    async handleConfirmAccount() {
        if (this.type === '' ||  this.name === ''|| this.cardNum === ''|| this.branch === '') {
            this.$message.error(`请将${this.type === '' ? '账户类型，' : ''}${this.name === '' ? '开户名称，' : ''}${this.cardNum === '' ? '银行卡号，' : ''}${this.branch === '' ? '开户网点，' : ''}填写完整`)
            return
        }
        if((this.type === 'PERSONAL'&&this.certificateNo=='')|| (this.type === 'PERSONAL'&&this.phoneNo=='')){
            this.$message.error(`请将${this.certificateNo === '' ? '身份证号，' : ''}${this.phoneNo === '' ? '手机号，' : ''}填写完整`)
            return
        }
        let flag = true
        if (this.type === 'PERSONAL') {
            /*身份证号码校验是否符合规则*/
            if (!getAgeByCardId(this.certificateNo)) {
                flag = false
                return
            }
            /*如果是个人账户，正则校验手机号格式是否正确*/
            if (this.phoneNo && !(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phoneNo))) {
                this.$message.error('请输入正确的手机号');
                flag = false
            }
        }
        if (!flag) {
            return
        }


        const obj = {
            type: this.type,
            name: this.name,
            cardNum: this.cardNum,
            branch: this.branch,
            certificateNo: this.certificateNo,
            phoneNo: this.phoneNo,
        }
        const { payeeInfoId } = await setPayeeInfo(delNullProperty(obj)) as unknown as { payeeInfoId: string}
        this.payInfo.id = payeeInfoId
        this.$set(this.payInfo, 'name', this.name)
        this.payInfo.cardNum = this.cardNum
        this.payInfo.branch = this.branch
        this.$set(this.payInfo, 'phoneNo', this.phoneNo)
        this.$set(this.payInfo, 'certificateNo', this.certificateNo)
        if (!this.certificateNo) {
            this.certificateNoDisabled = false
        } else {
            this.certificateNoDisabled = true
        }
        if (!this.phoneNo) {
            this.phoneNoDisabled = false
        } else {
            this.phoneNoDisabled = true
        }
        this.payInfo.type = this.type && this.type == 'PUBLIC' ? '对公账户' : this.type && this.type == 'PERSONAL' ? '个人账户': ''
        this.newAccountDialog = false

        //     清空上一次填写的数据
        this.type = ''
        this.name = ''
        this.cardNum = ''
        this.branch = ''
        this.certificateNo = ''
        this.phoneNo = ''
        this.$set(this.payInfo, 'selectedArea', [])
        this.$set(this.payInfo, 'selectedDetailArea', '')
        this.selectedOptions = []
    }

    changeDirectorUserId(e) {
        this.formData.directorUserId = e.id
    }

    handleChange(value) {
        // 如果需要获取中文名称，可以通过以下方式
        const province = this.findLabelByValue(this.options, value[0])
        const city = this.findLabelByValue(province.children, value[1])
        const district = this.findLabelByValue(city.children, value[2])
        this.payInfo.selectedArea = [province.label,city.label,district.label]
      }
      getSelectedLabels() {
        if (this.payInfo.selectedArea.length !==3) return []
        const province = this.options.find(item => item.label === this.payInfo.selectedArea[0])
        // 兼容小程序地址
        let city = null
        if(this.payInfo.selectedArea[1]===this.payInfo.selectedArea[0]) {
             city = province.children.find(item => item.label === '市辖区')
        } else {
             city = province.children.find(item => item.label.includes(this.payInfo.selectedArea[1]))
        }
        let district = city.children.find(item => item.label.includes(this.payInfo.selectedArea[2]))
          //   如果没有第三级 则回显前两级别，并补充第三级为'—'
          if (!district) {
              this.payInfo.selectedArea = [province.label, city.label, '—']
              district = {label: '—', value: city.value + '00'}
          }
        this.selectedOptions = [province.value, city.value, district.value]
      }
      // 根据value查找对应的label
      findLabelByValue(arr, value) {
        return arr.find(item => item.value === value)
      }
}
